import { Divider, DividerProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledDivider = styled<FC<DividerProps>>(Divider)`
  background-color: ${({ theme }) => theme.colors.gray4};
  height: 1px;
`;

export const StyledDivBottom = styled.div`
  margin-bottom: 36px;
`;

export const StyledDiv = styled(StyledDivBottom)`
  margin-top: 41px;
`;
